<div class="modal-content modal-content-right">
  <div class="modal-header">
    <h5 class="modal-title"><i class="fas fa-toolbox"></i>Cash Payment</h5>
    <button type="button" class="close" (click)="close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="justify-content-center">
      <div class="form-row">
        <div class="form-group col-md-12">
          <label>Client</label
          ><span class="pull-right" *ngIf="isCustomerLoading"
            ><i class="fas fa-spinner fa-spin"></i
          ></span>
          <input
            type="text"
            class="form-control"
            disabled
            value="{{ clientName }}"
          />
        </div>
        <div class="form-group col-md-12">
          <label>Amount</label>
          <input
            type="text"
            class="form-control"
            [ngClass]="{ 'is-invalid': paymentAmount == '' }"
            [ngModel]="paymentAmount | currency"
            [ngModelOptions]="{ standalone: true }"
            [disabled]="true"
          />
        </div>
        <div class="form-group col-md-12">
          <input
            type="checkbox"
            class="form-check form-check-inline"
            [(ngModel)]="cashPaymentModel.EmailReceiptToClient"
          /><span>Email Receipt to Client</span>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" (click)="close()">
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-outline"
      [disabled]="busy"
      (click)="saveCashPayment()"
    >
      Process Payment
      <span class="ml-2" *ngIf="busy"
        ><i class="fas fa-spinner fa-spin"></i
      ></span>
    </button>
  </div>
</div>
